import { FC } from 'react';

import BoxInfoOffer from './BoxInfoOffer';
import { useLingui } from '@lingui/react';
import dayjs from 'dayjs';

interface Props {
  carMake?: string;
  carLogo?: string;
  carModel: string;
  carYear: string;
  plateNumber: string;
  vinNumber: string;
  wheelSide: string;
  accidentWasInPoland: string;
}

const CarInfo: FC<Props> = ({
  carMake,
  // carLogo,
  carModel,
  carYear,
  plateNumber,
  vinNumber,
  wheelSide,
  accidentWasInPoland,
}) => {
  const { i18n } = useLingui();
  return (
    <div className="text-dark-gray-500 lg:max-w-[440px]">
      <h2 className="h4 mb-3 text-center">{i18n.t('Twój samochód')}</h2>
      <div className="mb-[30px] hidden h-px w-full bg-dark-gray-100 lg:block" />
      <div className="grid grid-cols-2 gap-2 lg:gap-x-5 lg:gap-y-4">
        <div className="col-span-2 flex items-center justify-between rounded-md border border-dark-gray-100 p-3">
          <div>
            <p className="input-label-small font-medium text-dark-gray-300">
              {i18n.t('Marka')}
            </p>
            <p className="body-small text-oxford-blue-500">{carMake}</p>
          </div>
          {/* hidden for now */}
          {/* <img
            src={carLogo}
            alt={`${carMake}-logo`}
            className="aspect-square size-10 rounded-full"
          /> */}
        </div>
        <BoxInfoOffer label="Model" value={carModel} />
        <BoxInfoOffer
          label="Rok produkcji"
          value={dayjs(carYear).format('YYYY')}
        />
        <BoxInfoOffer label="Nr rejestracyjny" value={plateNumber} />
        <BoxInfoOffer label="Nr VIN" value={vinNumber} />
        <BoxInfoOffer label="Strona kierownicy" value={wheelSide} />
        <BoxInfoOffer label="Wypadek w Polsce?" value={accidentWasInPoland} />
      </div>
    </div>
  );
};

export default CarInfo;
